'use strict';

var ScenarioSearchCriteriaService = function ScenarioSearchCriteriaService(searchCriteriaService) {
  function buildCriteria(screen, date) {
    return searchCriteriaService.getDefault(screen + '-opt-group').then(function (response) {
      response.context = screen;
      response.rules[1].leftOperand = date;
      return response;
    });
  }
  return {
    buildCriteria: buildCriteria
  };
};
ScenarioSearchCriteriaService.$inject = ['SearchCriteriaService'];
module.exports = ScenarioSearchCriteriaService;